module.exports = __webpack_public_path__ + "img/2_en.4ec16f9.png";